import React, { useRef } from 'react';

import Checkbox from '@components/custom/Checkbox';
import Icon from '@components/custom/Icon';

// eslint-disable-next-line react/display-name
const AccordionItemWithCheckboxes = React.memo(
  ({ filter, selectedOptions, onCheckboxChange, isOpen, onToggle }) => {
    const scrollRef = useRef();

    const handleChange = (value, e) => {
      const container = scrollRef.current;
      const prevScroll = container?.scrollTop ?? 0;

      onCheckboxChange(filter.id, value, e);

      requestAnimationFrame(() => {
        if (container) container.scrollTop = prevScroll;
      });
    };

    const onHeaderClick = (e) => {
      if (
        e.target.tagName === 'INPUT' ||
        e.target.tagName === 'LABEL' ||
        e.target.closest('.form-check')
      ) {
        return;
      }
      onToggle();
    };

    return (
      <div className="accordion-item">
        <div className="accordion-header d-flex align-items-center justify-content-between" onClick={ (e) => onHeaderClick(e) }>
          {filter.label}
          <Icon
            name='arrow_forward_ios'
            color='#5b5b5b'
            size={ 14 }
            style={ { marginRight: 0, rotate: isOpen ? '-90deg' : '90deg', transition: 'all 0.3s ease' } }
          />
        </div>
        <div
          className={ `accordion-body ${isOpen ? 'open' : 'collapsed'}` }
          ref={ scrollRef }
        >
          {filter.options.map(option => (
            <Checkbox
              key={ option.value }
              id={ `${filter.id}-${option.value}` }
              label={ option.label }
              value={ option.value }
              checked={ selectedOptions.includes(option.value) }
              onChange={ (e) => handleChange(option.value, e) }
            />
          ))}
        </div>
      </div>
    );
  },
  (prev, next) =>
    prev.isOpen === next.isOpen &&
    JSON.stringify(prev.selectedOptions) === JSON.stringify(next.selectedOptions) &&
    JSON.stringify(prev.filter.options) === JSON.stringify(next.filter.options)
);

export default AccordionItemWithCheckboxes;
